import PropTypes from 'prop-types';

export const propTypes = {
  id: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
};

export const defaultProps = {};

export default { defaultProps, propTypes };
